import React from "react";
import { store } from "../../../../../redux/store";
import { heights } from "../../../../../styles/romeu/heights";
import { widths } from "../../../../../styles/romeu/widths";
import { MasterCustomsStatesList } from "./list/list";
import { setCustomsStates } from "../../../../../redux/reducers/catalog/catalog";
import { resetMasterCustomsStatesList } from "../../../../../redux/reducers/resources/master/customsStates/list";

export class MasterCustomStatesContainer extends React.Component {
    componentWillUnmount(): void {
        store.dispatch(resetMasterCustomsStatesList());
        store.dispatch(setCustomsStates([]));
    }

    render(): React.ReactNode {
        return (
            <MasterCustomsStatesList
                widthPopUp={widths.master.default}
                heigthPopUp={heights.master.default}
            />
        );
    }
}
